import { apiRequest } from '@/utils/apiRequest'
import { apiUrl } from '@/utils/apiUrl'

export class AccountingRepository {
	constructor() {
		const host = window.location.hostname
		if (host === 'localhost' || host.startsWith('192.168')) {
			this.urlBase = process.env.VUE_APP_API_BASE_URL
		} else {
			this.urlBase = window.location.origin
		}
	}

	async getAccountingConfig() {
		try {
			const response = await apiRequest({ url: apiUrl('/world/api/accounting-config'), method: 'POST', body: {}, throwOnNonOk: false })
			if (!response.ok) return response.status
			return response.data
		} catch (e) {
			console.log('Ups, algo ha ido mal.')
		}
	}

	async registerAccountingSnapshot(data) {
		try {
			const response = await apiRequest({ url: apiUrl('/world/api/accounting/create-accounting-snapshot'), method: 'POST', body: data, throwOnNonOk: false })
			if (!response.ok) return response.status
			return response.data
		} catch (e) {
			console.log('Ups, algo ha ido mal.')
		}
	}

	async registerCashDrawerTransaction(data) {
		try {
			const response = await apiRequest({ url: apiUrl('/world/api/accounting/cash-drawer-transaction'), method: 'POST', body: data, throwOnNonOk: false })
			if (!response.ok) return response.status
			return response.data
		} catch (e) {
			console.log('Ups, algo ha ido mal.')
		}
	}

	async getCashDrawerTransactions(body = {}) {
		const { data } = await apiRequest({
			url: apiUrl('/world/api/accounting/cash-drawer-transactions'),
			method: 'POST',
			body,
		})
		return data
	}

	async getCashDrawerTransactionPrint(transactionId) {
		const { data } = await apiRequest({
			url: apiUrl(`/world/api/accounting/cash-drawer-transactions/${transactionId}/print`),
			method: 'GET',
		})
		return data
	}
}

export const accountingRepository = new AccountingRepository()
